export const ButtonPrimaryForegroundColor = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ButtonPrimaryForegroundColorHover = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ButtonPrimaryForegroundColorActive = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ButtonPrimaryBackgroundColor = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const ButtonPrimaryBackgroundColorHover = {
  value: "#0655b4ff",
  attributes: {
    appearance: {
      dark: {
        value: "#8ec6fbff"
      }
    }
  }
};
export const ButtonPrimaryBackgroundColorActive = {
  value: "#09458cff",
  attributes: {
    appearance: {
      dark: {
        value: "#68a0d5ff"
      }
    }
  }
};
export const ButtonPrimaryBorderColor = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ButtonPrimaryBorderRadius = { value: "0.375rem" };
export const ButtonPrimaryFocusRingColor = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const ButtonSecondaryForegroundColor = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ButtonSecondaryForegroundColorHover = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ButtonSecondaryForegroundColorActive = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ButtonSecondaryBackgroundColor = {
  value: "#0404040f",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff0f"
      }
    }
  }
};
export const ButtonSecondaryBackgroundColorHover = {
  value: "#05050522",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff22"
      }
    }
  }
};
export const ButtonSecondaryBackgroundColorActive = {
  value: "#07070735",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff35"
      }
    }
  }
};
export const ButtonSecondaryBorderColor = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ButtonSecondaryBorderRadius = { value: "0.375rem" };
export const ButtonSecondaryFocusRingColor = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const ButtonGhostForegroundColor = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ButtonGhostForegroundColorHover = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ButtonGhostForegroundColorActive = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ButtonGhostBackgroundColor = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ButtonGhostBackgroundColorHover = {
  value: "#14141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff14"
      }
    }
  }
};
export const ButtonGhostBackgroundColorActive = {
  value: "#14141429",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff29"
      }
    }
  }
};
export const ButtonGhostBorderColor = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ButtonGhostBorderRadius = { value: "0.375rem" };
export const ButtonGhostFocusRingColor = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const ButtonDangerPrimaryForegroundColor = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ButtonDangerPrimaryForegroundColorHover = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ButtonDangerPrimaryForegroundColorActive = {
  value: "#ffffff",
  attributes: {
    appearance: {
      dark: {
        value: "#141414"
      }
    }
  }
};
export const ButtonDangerPrimaryBackgroundColor = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const ButtonDangerPrimaryBackgroundColorHover = {
  value: "#b82c12ff",
  attributes: {
    appearance: {
      dark: {
        value: "#ff8a79ff"
      }
    }
  }
};
export const ButtonDangerPrimaryBackgroundColorActive = {
  value: "#8f2613ff",
  attributes: {
    appearance: {
      dark: {
        value: "#d96553ff"
      }
    }
  }
};
export const ButtonDangerPrimaryBorderColor = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ButtonDangerPrimaryBorderRadius = { value: "0.375rem" };
export const ButtonDangerPrimaryFocusRingColor = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const ButtonDangerSecondaryForegroundColor = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const ButtonDangerSecondaryForegroundColorHover = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const ButtonDangerSecondaryForegroundColorActive = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const ButtonDangerSecondaryBackgroundColor = {
  value: "#ffece9",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f33"
      }
    }
  }
};
export const ButtonDangerSecondaryBackgroundColorHover = {
  value: "#fcd9d4ff",
  attributes: {
    appearance: {
      dark: {
        value: "#fe6e5852"
      }
    }
  }
};
export const ButtonDangerSecondaryBackgroundColorActive = {
  value: "#f6b4a9ff",
  attributes: {
    appearance: {
      dark: {
        value: "#fe6a5466"
      }
    }
  }
};
export const ButtonDangerSecondaryBorderColor = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const ButtonDangerSecondaryBorderRadius = { value: "0.375rem" };
export const ButtonDangerSecondaryFocusRingColor = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const CheckboxUncheckedFillColorDefault = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const CheckboxUncheckedFillColorHover = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const CheckboxUncheckedFillColorActive = {
  value: "#141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff"
      }
    }
  }
};
export const CheckboxUncheckedBackgroundColorDefault = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const CheckboxUncheckedBackgroundColorHover = {
  value: "#14141414",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff14"
      }
    }
  }
};
export const CheckboxUncheckedBackgroundColorActive = {
  value: "#14141429",
  attributes: {
    appearance: {
      dark: {
        value: "#ffffff29"
      }
    }
  }
};
export const CheckboxCheckedFillColorDefault = {
  value: "#0265DC",
  attributes: {
    appearance: {
      dark: {
        value: "#78BBFA"
      }
    }
  }
};
export const CheckboxCheckedFillColorHover = {
  value: "#004ba0d1",
  attributes: {
    appearance: {
      dark: {
        value: "#abd8feda"
      }
    }
  }
};
export const CheckboxCheckedFillColorActive = {
  value: "#0151afb8",
  attributes: {
    appearance: {
      dark: {
        value: "#abd8fee0"
      }
    }
  }
};
export const CheckboxCheckedBackgroundColorDefault = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const CheckboxCheckedBackgroundColorHover = {
  value: "#0265dc14",
  attributes: {
    appearance: {
      dark: {
        value: "#78bbfa14"
      }
    }
  }
};
export const CheckboxCheckedBackgroundColorActive = {
  value: "#0265dc29",
  attributes: {
    appearance: {
      dark: {
        value: "#78bbfa29"
      }
    }
  }
};
export const CheckboxUncheckedErrorFillColorDefault = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const CheckboxUncheckedErrorFillColorHover = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const CheckboxUncheckedErrorFillColorActive = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const CheckboxUncheckedErrorBackgroundColorDefault = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const CheckboxUncheckedErrorBackgroundColorHover = {
  value: "#e132120f",
  attributes: {
    appearance: {
      dark: {
        value: "#f94d321a"
      }
    }
  }
};
export const CheckboxUncheckedErrorBackgroundColorActive = {
  value: "#e132122e",
  attributes: {
    appearance: {
      dark: {
        value: "#f94d3240"
      }
    }
  }
};
export const CheckboxCheckedErrorFillColorDefault = {
  value: "#e13212",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const CheckboxCheckedErrorFillColorHover = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const CheckboxCheckedErrorFillColorActive = {
  value: "#bf2a00",
  attributes: {
    appearance: {
      dark: {
        value: "#ff745f"
      }
    }
  }
};
export const CheckboxCheckedErrorBackgroundColorDefault = {
  value: "transparent",
  attributes: {
    appearance: {
      dark: {
        value: "transparent"
      }
    }
  }
};
export const CheckboxCheckedErrorBackgroundColorHover = {
  value: "#e132120f",
  attributes: {
    appearance: {
      dark: {
        value: "#f94d321a"
      }
    }
  }
};
export const CheckboxCheckedErrorBackgroundColorActive = {
  value: "#e132122e",
  attributes: {
    appearance: {
      dark: {
        value: "#f94d3240"
      }
    }
  }
};